.goldInfoBox {
  width: 100%;
  box-shadow: 0 2px 16px 0 rgb(0 0 0 / 5%), 0 0 0 1px rgb(0 0 0 / 5%);
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
}

.janeGoldLogo {
  position: absolute;
  top: 12px;
  right: 24px;
}

@media all and (--reefer-media-tablet-min) {
  .goldInfoBoxContainer {
    position: sticky;
    margin-top: 24px;
  }

  .goldInfoBox {
    width: 420px;
    min-width: 420px;
    height: fit-content;
    align-self: flex-start;
  }
}
